export default "__VITE_ASSET__zG3Q4GSq__"